/**
 * Export `searchOnInput`.
 */

export function searchOnInput(input: string, option: any) {
  return (option?.label ?? '').toLowerCase().includes(input.toLowerCase());
}
